import { render, staticRenderFns } from "./laPaFeeType.vue?vue&type=template&id=818eaef0&scoped=true&"
import script from "./laPaFeeType.vue?vue&type=script&lang=js&"
export * from "./laPaFeeType.vue?vue&type=script&lang=js&"
import style0 from "./laPaFeeType.vue?vue&type=style&index=0&id=818eaef0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818eaef0",
  null
  
)

export default component.exports